export default __webpack_public_path__ + "static/media/Me1.800d4b24.png";